"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { useRef, useState } from "react";
import { Card, CommitteeHeader } from "@components/common/card";
import Pagination from "@components/common/pagination";
import type { MemberDocument, MemberDocuments } from "@lib/api/member/types";
import { routes } from "@lib/navigation";
import { body } from "@lib/utils/json";
interface DocumentProps {
  document: MemberDocument;
}
function Document(t0) {
  const $ = _c(20);
  const {
    document
  } = t0;
  let t1;
  if ($[0] !== document.id) {
    t1 = routes.document(document.id);
    $[0] = document.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== document.committee) {
    t2 = <CommitteeHeader committee={document.committee} />;
    $[2] = document.committee;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== document.title) {
    t3 = <p className="text-sm text-slate-600 dark:text-slate-400">{document.title}</p>;
    $[4] = document.title;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== document.altTitle) {
    t4 = <p className="pb-1">{document.altTitle}</p>;
    $[6] = document.altTitle;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== document.subtitle) {
    t5 = <p className="text-sm text-slate-600 dark:text-slate-400">{document.subtitle}</p>;
    $[8] = document.subtitle;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
    t6 = <div className="p-4 ">{t3}{t4}{t5}</div>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t2 || $[15] !== t6) {
    t7 = <Card className="p-0 transition-opacity hover:opacity-75 dark:shadow-slate-900">{t2}{t6}</Card>;
    $[14] = t2;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t1 || $[18] !== t7) {
    t8 = <Link href={t1} prefetch={false}>{t7}</Link>;
    $[17] = t1;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}
interface Props {
  memberId: string;
  initialDocuments: MemberDocuments;
}
export default function Documents(t0) {
  const $ = _c(17);
  const {
    initialDocuments,
    memberId
  } = t0;
  const containerRef = useRef(null);
  const [page, setPage] = useState(1);
  const [documents, setDocuments] = useState(initialDocuments.documents);
  let t1;
  if ($[0] !== memberId) {
    t1 = async function changePage(page_0) {
      const response = await fetch(`${window.location.origin}${routes.api.memberDocument(memberId, page_0)}`, {
        next: {
          revalidate: 86400
        }
      });
      const newDocuments = await body(response);
      setPage(page_0);
      setDocuments(newDocuments.documents);
      containerRef.current?.scrollIntoView();
    };
    $[0] = memberId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const changePage = t1;
  if (initialDocuments.pages === 0) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="m-4"><p className="text-center text-lg">Inga dokument hittades.</p></div>;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let t2;
  if ($[3] !== changePage || $[4] !== initialDocuments.pages || $[5] !== page) {
    t2 = <Pagination current={page} total={initialDocuments.pages} onChange={changePage} />;
    $[3] = changePage;
    $[4] = initialDocuments.pages;
    $[5] = page;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== documents) {
    t3 = documents.map(_temp);
    $[7] = documents;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== changePage || $[10] !== initialDocuments.pages || $[11] !== page) {
    t4 = <Pagination current={page} total={initialDocuments.pages} onChange={changePage} />;
    $[9] = changePage;
    $[10] = initialDocuments.pages;
    $[11] = page;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t2 || $[14] !== t3 || $[15] !== t4) {
    t5 = <div className="scroll-mt-header-with-margin sm:scroll-mt-header-sm-with-margin m-4 flex flex-col gap-4" ref={containerRef}>{t2}{t3}{t4}</div>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}
function _temp(document) {
  return <Document key={document.id} document={document} />;
}